import { createFieldChangedChecker } from './createFieldChangedChecker'

/**
 * Creates common column attributes to reduce repetition across column components
 *
 * @param {Object} params - Column configuration
 * @param {boolean} params.filter - Whether filtering is enabled
 * @param {string} params.title - Column title
 * @param {boolean} params.sortable - Whether sorting is enabled
 * @param {boolean} params.editable - Whether the column is editable
 * @param {boolean|Function} params.isFieldChangedOverride - Override for field changed detection
 * @param {Function} params.defaultIsFieldChanged - Default change detection function
 * @param {string} params.mapsToField - Field name the column maps to
 * @param {Object} params.originalData - Original data for comparison
 * @returns {Object} Common column attributes
 */
export const createColumnAttributes = ({
    filter,
    title,
    sortable,
    editable,
    isFieldChangedOverride,
    defaultIsFieldChanged,
    mapsToField,
    originalData
}) => {
    const filterAttributes = {
        filter,
        filterPlaceholder: `Search by ${title}`,
        required: !!filter,
        disabled: !filter
    }

    const sortAttributes = {
        sortable,
        required: !!sortable,
        disabled: !sortable
    }

    const checkFieldChanged = createFieldChangedChecker({
        editable,
        isFieldChangedOverride,
        defaultIsFieldChanged,
        mapsToField,
        originalData
    })

    return {
        filterAttributes,
        sortAttributes,
        checkFieldChanged
    }
}
